import {useHovercardAttributesForIssue} from '@github-ui/hovercards/issue'
import {useIssueState} from '@github-ui/issue-pr-state'
import {Link, StateLabel} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import {TEST_IDS} from '../../constants/test-ids'
import type {HeaderState$data, HeaderState$key} from './__generated__/HeaderState.graphql'
import styles from './HeaderState.module.css'

type HeaderStateProps = {
  isSticky: boolean // whether it is rendered in the normal header or in the sticky header
  stateData: HeaderState$key
}

export function HeaderState({isSticky, stateData}: HeaderStateProps) {
  const {state, stateReason, duplicateOf} = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment HeaderState on Issue {
        state
        stateReason
        duplicateOf {
          number
          url
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    `,
    stateData,
  )
  const {stateString, stateStatus} = useIssueState({
    state,
    stateReason,
    options: {longText: !isSticky},
  })

  return (
    <div>
      <StateLabel data-testid={TEST_IDS.headerState} status={stateStatus} className={styles.stateLabel}>
        {stateString}
        {<DuplicateIssueLink duplicateOf={duplicateOf} />}
      </StateLabel>
    </div>
  )
}

function DuplicateIssueLink({duplicateOf}: {duplicateOf?: HeaderState$data['duplicateOf']}) {
  const hovercardAttrs = useHovercardAttributesForIssue({
    repo: duplicateOf?.repository?.name ?? '',
    owner: duplicateOf?.repository?.owner?.login ?? '',
    issueNumber: duplicateOf?.number ?? 0,
  })

  if (!duplicateOf) return null

  const shouldShowHovercard = duplicateOf.repository?.owner?.login

  return (
    <>
      {' '}
      of
      <Link
        href={duplicateOf?.url}
        inline
        {...(shouldShowHovercard ? hovercardAttrs : {})}
        className={styles.duplicateIssueLink}
      >
        #{duplicateOf?.number}
      </Link>
    </>
  )
}
